{
  "members": "Members",
  "inviteUser": "Invite user",
  "invite": "Invite",
  "inviteNeedsVerification": "Confirm your email address to invite people to this workspace.",
  "resendInvite": "Resend invite",
  "removeUser": "Remove user",
  "settings": "Settings",
  "createWorkspace": "Create Workspace",
  "nudge": "This is your personal workspace. Want to <newWorkspaceLink>create a separate workspace</newWorkspaceLink> for your team?",
  "roleUpdated": "Role updated for {{name}} to {{role}}",
  "inviteResent": "Invite email resent to {{name}}",
  "userRemoved": "{{name}} removed from the workspace",
  "changeRoleTitle": "Change role for {{name}}",
  "workspaceLanguage": {
    "title": "Workspace language",
    "description": "The default language for invitations sent from this workspace and its notification emails.",
    "label": "Default language",
    "success": "Workspace language updated"
  }
}
